import { initializeApp, getApps } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyCKVH2-6yTAXHEUoFpVM8mKUPXpFDULUnY",
  authDomain: "inker-d7c2d.firebaseapp.com",
  projectId: "inker-d7c2d",
  storageBucket: "inker-d7c2d.firebasestorage.app",
  messagingSenderId: "237932451632",
  appId: "1:237932451632:web:658f2a167927fe1c411af5"
};

// Initialize Firebase
let firebaseApp;
if (!getApps().length) {
  firebaseApp = initializeApp(firebaseConfig);
} else {
  firebaseApp = getApps()[0];
}

// Get messaging instance (only in browser)
let messaging = null;
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  try {
    messaging = getMessaging(firebaseApp);
  } catch (error) {
    console.log('Firebase messaging not supported:', error);
  }
}

export const requestNotificationPermission = async () => {
  if (!messaging) {
    console.log('Messaging not available');
    return null;
  }

  try {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      // Get FCM token
      const token = await getToken(messaging, {
        vapidKey: 'YOUR_VAPID_KEY' // We'll get this from Firebase Console
      });
      return token;
    }
    return null;
  } catch (error) {
    console.error('Error getting notification permission:', error);
    return null;
  }
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    if (!messaging) {
      resolve(null);
      return;
    }
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });

export { firebaseApp, messaging };
